import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faDatabase, faStethoscope, faClipboardCheck, faMoneyBillWave, faGift, faExclamationTriangle, faMinusCircle, faBed, 
  faBandAid, faMapMarkerAlt,faMoneyCheck, faBullhorn, faChalkboardTeacher, faTasks, faUserSlash, faClock, faAmbulance, faCertificate,
  faIdCard
} from '@fortawesome/free-solid-svg-icons';
import './ThinkContract.css';

function ThinkContractJobBoard() {

  const LinkButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  const LinkNoButton = ({ to, icon, label }) => (
    <div className="flex justify-center">
      <Link
        to={to}
        className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
      >
        <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
        <span>{label}</span>
      </Link>
    </div>
  );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 flex flex-col items-center py-8">
        <p className="text-xl font-bold text-white text-center mb-4">ThinkContract Job Board</p>
        

        
      </div>
    </MainLayout>
  );
}

export default ThinkContractJobBoard;
